import { render, staticRenderFns } from "./centerDashboard.vue?vue&type=template&id=02d34360&"
import script from "./centerDashboard.vue?vue&type=script&lang=js&"
export * from "./centerDashboard.vue?vue&type=script&lang=js&"
import style0 from "./centerDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports